import firebase from 'firebase'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyAL94joRbP6DE4RwU71U_uKAdvmBD6AdmE',
  authDomain: 'hktrcuser.firebaseapp.com',
  databaseURL: 'https://hktrcuser.firebaseio.com',
  projectId: 'hktrcuser',
  storageBucket: 'hktrcuser.appspot.com',
  messagingSenderId: '549130899629',
  appId: '1:549130899629:web:72772751cff50502ff7624',
  measurementId: 'G-8LVYM4BG7Z'
}

firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const auth = firebase.auth()
const currentStaff = auth.currentStaff

const staffCollection = db.collection('staffs')
const shopCollection = db.collection('shops')
const reservationCollection = db.collection('reservations')
const quotationCollection = db.collection('quotations')
const customerDetailsCollection = db.collection('customersDetails')
const remedialCourseCollection = db.collection('remedialCourse')
const userCollection = db.collection('user')

export {
  db,
  auth,
  currentStaff,
  staffCollection,
  shopCollection,
  reservationCollection,
  quotationCollection,
  customerDetailsCollection,
  remedialCourseCollection,
  userCollection
}
